import { render, staticRenderFns } from "./ProductsResale.vue?vue&type=template&id=0c907068&scoped=true"
import script from "./ProductsResale.vue?vue&type=script&lang=js"
export * from "./ProductsResale.vue?vue&type=script&lang=js"
import style0 from "./ProductsResale.vue?vue&type=style&index=0&id=0c907068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c907068",
  null
  
)

export default component.exports